import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconReportsDefault,
    iconReports,
    iconSearch,
    iconParameters,
    iconPayment,
    iconZonification,
    iconMassiveConsult,
    iconParametersGyg,
    iconPolizas,
    iconDigitalSignature,
    iconCar,
    iconAddDocs,
    iconDocs,
    iconCertificate,
    iconEmployeesCredits,
    iconParametersDefault,
    iconPerson,
    iconNeighborhood,
    iconUsers,
    iconWarranty,
    iconHandshake,
} from '../defaultValues';

const data = {
    role_5a9e8fae727c4c6f80bff3650cfd9857: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'gogo2',
            icon: iconEmployeesCredits,
            label: 'Créditos Empleados',
            to: '/app/employees',
        },
        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            to: '/app/radicationWarranty',

        },
        {
            id: 'financialSolutions',
            icon: iconHandshake,
            label: 'Soluciones Financieras',
            to: '/app/financialSolutions/list',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'cartera',
            icon: iconReportsDefault,
            label: 'Cartera',
            subs: [
                {
                    id: 'mora-collection',
                    icon: iconReportsDefault,
                    label: 'Mora',
                    to: '/app/collection/lista',
                },
                {
                    id: 'par1&par30-collection',
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30',
                },
                {
                    id: 'par1&par30C-collection',
                    icon: iconReportsDefault,
                    label: 'Comparativo Cartera',
                    to: '/app/collection/per1AndPer30Comparative',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Aprobadas vs Desembolsadas',
                    to: '/app/collection/ComparatibeApproveDisbursed',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Tuberia',
                    to: '/app/collection/Pipeline',
                },
            ],
        },
        {
            id: 'zonification',
            icon: iconZonification,
            label: 'Zonificación',
            to: '/app/zonification',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo 12 meses',
                    to: '/app/reports/comparative12Months',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Equipos',
                    to: '/app/reports/teamPerformance',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo Productividad',
                    to: '/app/reports/productivityComparative',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Cierre Mes',
                    to: '/app/reports/reportMonthEnd',
                },
                {
                    id: 'tiempos de respuesta',
                    icon: iconReportsDefault,
                    label: 'Tiempos de Respuesta',
                    to: '/app/reports/reportAnswerTimes',
                },
                {
                    id: 'seguimiento',
                    icon: iconReportsDefault,
                    label: 'Seguimiento',
                    to: '/app/reports/reportsRequestTracking',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Garantías Comunitarias',
                    to: '/app/reports/communityGuarantees',
                },
                {
                    icon: iconReportsDefault,
                    label: 'FNG',
                    to: '/app/reports/annexes',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconReportsDefault,
                            label: 'Reporte',
                            to: '/app/reports/annexes',
                        },
                        {
                            id: 'fng-cir',
                            icon: iconReportsDefault,
                            label: 'CIR',
                            to: '/app/reports/reportCir',
                        },
                    ],
                },
                {
                    icon: iconReportsDefault,
                    label: 'Recaudos Pasarelas',
                    to: '/app/reportGatewayPayment',
                },
            ],
        },
        {
            id: 'Preaprobador-masivo',
            icon: iconMassiveConsult,
            label: 'Pre aprobador Masivo',
            to: '/app/preAprobadorMasivo/Consultas',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },
        {
            icon: iconDigitalSignature,
            label: 'Firma Electrónica',
            to: '/app/electronicSignature/ElectronicSignature',
        },
        {
            id: 'operaciones',
            icon: iconPolizas,
            label: 'Operaciones',
            subs: [
                {
                    id: 'reprocess',
                    icon: iconPolizas,
                    label: 'Reprocesar desembolso',
                    to: '/app/ReprocessDisbursements',
                },
                {
                    id: 'consulta',
                    icon: iconPolizas,
                    label: 'Excepciones',
                    to: '/app/credits/ExceptionDocuments',
                },
                {
                    id: 'vehiculos',
                    icon: iconCar,
                    label: 'Vehículos',
                    to: '/app/credits/VehicleDocuments',
                },
                {
                    id: 'documents',
                    icon: iconAddDocs,
                    label: 'Documentos',
                    to: '/app/credits/DisbursementDocuments',
                },
                {
                    id: 'runtPreRegistration',
                    icon: iconAddDocs,
                    label: 'Pre registro RUNT',
                    to: '/app/credits/RuntPreRegistration',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            subs: [
                {
                    id: 'certificados',
                    icon: iconCertificate,
                    label: 'Certificados',
                    to: '/app/reports/peaceAndSafe',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Registrar',
                            to: '/app/reports/peaceAndSafe',
                        },
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Consultar',
                            to: '/app/reports/checkCertificates',
                        },
                    ],
                },
            ],
        },
        {
            id: 'cobranza',
            icon: iconPayment,
            label: 'Cobranza',
            to: '/app/signaturePayment',
        },
        {
            id: 'docs',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/clients',
            subs: [
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/calculatorParams',
                },
                {
                    id: 'gyg',
                    icon: iconParametersGyg,
                    label: 'G&G',
                    to: '/app/gyg/parameterGyg',
                },
                {
                    icon: iconParametersDefault,
                    label: 'Concesionarios',
                    to: '/app/concesionarios',
                },
                {
                    icon: iconParametersDefault,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
                {
                    id: 'personas',
                    icon: iconPerson,
                    label: 'Personas',
                    to: '/app/persons',
                },
                {
                    id: 'barrios',
                    icon: iconNeighborhood,
                    label: 'Barrios',
                    to: '/app/barrios',
                },
                {
                    id: 'usuarios',
                    icon: iconUsers,
                    label: 'Usuarios',
                    to: '/app/usuarios',
                },
                {
                    id: 'social-reasons',
                    icon: iconReportsDefault,
                    label: 'Terceros',
                    to: '/app/socialReasons',
                },
            ],
        },
    ],
};
export default data;
